/* ------------------------------------------------------------------ */
/* Shared currency and percentage formatting for calculator tools      */
/* ------------------------------------------------------------------ */

export function formatCurrency(value: number): string {
  if (Math.abs(value) >= 1000) {
    return `£${value.toLocaleString("en-GB", { maximumFractionDigits: 0 })}`
  }
  return `£${value.toFixed(0)}`
}

export function formatCurrencyPence(value: number): string {
  return `£${value.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function formatPercent(value: number): string {
  return `${value.toFixed(2)}%`
}
